import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalComponent } from '../../shared/components/modal/modal.component';
import { Distributor } from '../../shared/models/Distributor';
import { FilterObject } from '../../shared/models/FilterObject';
import { PagingResults } from '../../shared/models/PagingResult';
import { RMA } from '../../shared/models/RMA';
import { RMAItem } from '../../shared/models/RMAItem';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { faShare, faEye } from '@fortawesome/free-solid-svg-icons';
import { RMAResponse } from '../../shared/models/RMAResponse';
import { HttpResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dashboard-rma',
  templateUrl: './rma.component.html',
  styleUrls: ['./rma.component.css']
})
export class DashboardRmaComponent implements OnInit, OnDestroy {
  readonly Page: string = "RMA";
  HideComponent: boolean;
  RMAList: RMA[];
  DistList: Distributor[];
  DistSubscription: Subscription;
  CurrentDist: string;
  CurUser: User;
  HideDist: boolean;
  RMASortValue: string;
  FilterList: FilterObject[];
  CustFilter: FilterObject;
  PageIndex: number;
  PageSize: number;
  faShare = faShare;
  faEye = faEye;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];
  hideLoadingModal: boolean;
  constructor(private http: HttpService, private global: GlobalService, private router: Router, public matDialog: MatDialog) { }


  ngOnInit(): void {
    this.hideLoadingModal = true;
    this.HideComponent = false;
    this.RMASortValue = "received";
    this.PageIndex = 0;
    this.PageSize = 10;

    var dist = this.global.getCurrentDist();
    this.CurUser = new User();
    this.CustFilter = new FilterObject();
    this.CustFilter.Key = "customer";

    this.global.getCurrentUser().then(x => {
      this.CurUser = x;

      if (!this.CurUser.HasPagePermission("rma")) {
        this.HideComponent = true;
      }
      else {
        if (this.CurUser.IsTolomaticUser) {
          this.HideDist = false;
        }
        else {
          this.HideDist = true;
        }

        this.http.GetDistributors().then(x => {
          if (x.StatusCode == "200") {
            this.DistList = x.Content;

            if (dist) {
              if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId == dist.CompanyId) {
                this.CurrentDist = dist.CompanyId;
              }
              else if (this.CurUser.IsTolomaticUser) {
                this.CurrentDist = dist.CompanyId;
              }
              else {
                this.CurrentDist = this.CurUser.DistributorId;
              }
            }
            else {
              if (!this.CurUser.IsTolomaticUser && this.CurUser.DistributorId != "") {
                this.CurrentDist = this.CurUser.DistributorId;
              } else {
                this.CurrentDist = this.DistList[0].CompanyId;
              }
            }

            this.CustFilter.Value = this.CurrentDist;
            this.FilterList = [];
            this.FilterList.push(this.CustFilter);
            this.LoadRMAs();
          }

        });
        var initialLoad = true;
        this.DistSubscription = this.global.CurrentDist.subscribe(dist => {
          if (dist && dist.CompanyId != this.CurrentDist && !initialLoad) {
            this.CurrentDist = dist.CompanyId;
            this.CustFilter.Value = this.CurrentDist;
            this.LoadRMAs();

          }
          initialLoad = false;
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.DistSubscription) {
      this.DistSubscription.unsubscribe();
    }
  }

  LoadRMAs() {
    this.hideLoadingModal = false;
    this.http.GetRMA(this.FilterList, this.CurUser.UserId.toString(), this.PageIndex, this.PageSize,this.RMASortValue).then(x => {
      if (x.StatusCode == "200") {
        var results = <PagingResults>x.Content;
        this.RMAList = results.Items;
        this.RMAList.forEach(x => {
          x.ShortShipTo = x.ShipToName;
          //x.ShortReason = x.Reason;
          if (x.ShortShipTo.length > 20) {
            x.ShortShipTo = x.ShortShipTo.substring(0, 20) + "...";
          }
          //x.RMAItems.forEach(y => {
          //  y.ShortReason = y.Reason;
          //  y.ShortDesc = y.Description
          //  if (y.ShortReason.length > 20) {
          //    y.ShortReason = y.ShortReason.substring(0, 20) + "...";
          //  }
          //  if (y.ShortDesc.length > 25) {
          //    y.ShortDesc = y.ShortDesc.substring(0, 25) + "...";
          //  }
          //});
          
        });
      }
      this.hideLoadingModal = true;
    });
  }

  LoadDetails(rma: RMA) {
    if (!rma.RMAItems) {
      this.hideLoadingModal = false;
      this.http.GetRMAItems(rma.RMANumber, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {
          rma.RMAItems = x.Content;
          rma.RMAItems.forEach(item => {
            item.ShortReason = item.Reason.length > 35 ? item.Reason.substring(0, 35) + "..." : item.Reason;
            item.ShortDesc = item.Description.length > 35 ? item.Description.substring(0, 35) + "..." : item.Description;
          });
        }
        this.hideLoadingModal = true;
      });
    }
  }

  Dist_Change(event: any) {
    //this.CurrentDist = event.value;
    //this.CustFilter.Value = this.CurrentDist;
    var newDist = this.DistList.filter(x => x.CompanyId == event.value)[0];
    this.global.setCurrentDist(newDist);
    //this.LoadRMAs();
  }

  RMASort_Change(event: any) {
    this.RMASortValue = event.value;
    this.LoadRMAs();
  }

  OpenRMAItem(rma:RMA, rmaItem:RMAItem) {
    var dialogConfig = this.GetDialogConfig("RMAItem");

    var rmaObject = {
      type: "RMA", object: { rma: rma, rmaItem: rmaItem }
    };
    dialogConfig.data = rmaObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  RespondToRMA(rma: RMA) {
    var dialogConfig = this.GetDialogConfig("RMARespond");

    var rmaObject = { type: "RMAResponse", object: rma };
    dialogConfig.data = rmaObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {

      var response = <RMAResponse>event;

      this.SubmitResponse(response).then(success => {
        if (success) {
          this.CurrentOpenDialog.close();
        }
      });

    });

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CurrentOpenDialog.close();
    });
  }

  ViewRMAEval(rma: RMA) {
    if (rma.RMAVerificationPath.length > 0) {
      this.hideLoadingModal = false;
      this.http.DownloadRMAVerification(rma.RMANumber).subscribe(({ body, headers }: HttpResponse<any>) => {
        debugger;
        var contentType = headers.get('content-type');
        const blob = new Blob([body], { type: contentType });
        var fileURL = URL.createObjectURL(blob);

        var a = document.createElement("a");
        a.href = fileURL;
        a.download = rma.RMANumber + ".pdf";
        a.click();
        this.hideLoadingModal = true;
      });
    }
  }

  async SubmitResponse(response: RMAResponse): Promise<boolean> {
    if (response.Action != "" && response.RMANumber != null) {

      this.hideLoadingModal = false;
      return await this.http.SubmitRMAResponse(response, this.CurUser.UserId.toString()).then(x => {
        if (x.StatusCode == "200") {
          this.hideLoadingModal = true;
          return true;
        }
        else {
          this.hideLoadingModal = true;
          return false;
        }
        
      });
    }
  }

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "80%";
    dialogConfig.width = "70%";

    return dialogConfig;
  }

  FollowOrder(checked: boolean, rmaItemRowPointer: string) {
    this.http.PostUserActivity(this.CurUser.UserId.toString(), "RMA", "Follow RMA", rmaItemRowPointer);
    this.http.FollowRMA(checked, rmaItemRowPointer, this.CurUser.UserId.toString());
  }

  ViewFullDetails() {
    this.router.navigateByUrl('/rma', { state: { sortValue: this.RMASortValue, distributor: this.CurrentDist } });
  }

  GetRMAItemStatusText(item: RMAItem): string {
    if (item.RMAStatus == "F" && item.RepairOrder.indexOf("SV") < 0 && item.Disp.length > 0) {
      return "In Order Entry";
    }
    else if (item.RMAStatus == "F" && item.RepairOrder.indexOf("SV") < 0) {
      return "Response Needed";
    }
    else if (item.RMAStatus == "F" && item.RepairOrder.indexOf("SV") >= 0) {
      return "In Process";
    }
    else {
      return item.RMAStatus;
    }
    

  }

}
